export interface IAuthorizationStep {
  title: string;
  description: string;
  banks?: string[];
  link?: string;
  steps?: {
    image?: string;
    video?: string;
    videoOrientation?: "vertical" | "horizontal";
    title: string;
    description: string;
    link?: string;
    banks?: string[];
  }[];
}

const FGTS_BANKS = [
  "QI SOCIEDADE DE CRÉDITO",
  "QI CORRETORA DE TÍTULOS E VALORES IMOBILIÁRIOS S.A",
  "J17 SOCIEDADE DE CRÉDITO",
];

export const useAuthorizationContent = (type: string, linkPan?: string) => {
  const content: Record<string, IAuthorizationStep> = {
    FGTS: {
      title: "Autorize o acesso ao seu FGTS",
      description:
        "Para continuar, é preciso autorizar o acesso no app do seu bancos:",
      banks: FGTS_BANKS,
      steps: [
        {
          video: "https://www.youtube.com/embed/aphrf4Y_iY8",
          videoOrientation: "vertical",
          title: "",
          description:
            "Siga o passo a passo do vídeo acima e realize a liberação dos seguintes bancos para fazer sua simulação:",
          banks: FGTS_BANKS,
        },
      ],
    },
    PAN: {
      title: "Autorize o acesso ao PAN",
      description:
        "Para continuar, é preciso autorizar o acesso via WhatsApp. É rápido e seguro",
      steps: [
        {
          image: "/passoPan1.png",
          title: "Passo 1",
          description: "Abra o link e envie a mensagem",
          link: linkPan,
        },
        {
          image: "/passoPan2.png",
          title: "Passo 2",
          description:
            "Em seguida, aguarde o retorno do PAN sobre a autorização, o tempo de retorno pode variar por cliente",
        },
        {
          image: "/passoPan3.png",
          title: "Passo 3",
          description:
            "Após o retorno do PAN sobre a autorização ficará disponível a simulação para prossseguir para finalização",
        },
      ],
    },
  };

  return {
    content: content[type] as IAuthorizationStep | undefined,
  };
};
